import { useEffect, useState } from 'react';
import { API_URL, authFetch, parseJsonResponse, responseErrorMessage } from '../utils/auth';
import ClientFilesPage from '../clients/files/ClientFilesPage';

export default function Files() {
  const [files, setFiles] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function loadFiles() {
    setLoading(true);
    setError('');
    try {
      const [filesRes, projectsRes] = await Promise.all([
        authFetch(API_URL + '/client/files/'),
        authFetch(API_URL + '/client/projects/'),
      ]);
      const filesData = await parseJsonResponse(filesRes);
      const projectsData = await parseJsonResponse(projectsRes);
      if (!filesRes.ok) throw new Error(responseErrorMessage(filesRes, filesData, 'Unable to load files.'));
      if (!projectsRes.ok) throw new Error(responseErrorMessage(projectsRes, projectsData, 'Unable to load projects.'));
      setFiles(Array.isArray(filesData) ? filesData : filesData?.results || []);
      setProjects(Array.isArray(projectsData) ? projectsData : projectsData?.results || []);
    } catch (err) {
      console.error(err);
      setError(err.message || 'Unable to load files.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { loadFiles(); }, []);

  return <ClientFilesPage files={files} projects={projects} loading={loading} error={error} onUploaded={loadFiles} />;
}
